import React from 'react';
import { css, isPropValid, styled } from '../../styled-components';
import { bikeworldStyles, doitGardenStyles, famigrosStyles, melectronicsStyles, mgbStyles, micasaStyles, migipediaStyles, migrosAppStyles, migrosServiceStyles, migustoStyles, sportxxStyles } from '../button/styles';
import { ICON_BUTTON_SIZE } from './helpers/config';
export const IconButton = ({
  onClick,
  className,
  icon,
  ariaLabel
}) => /*#__PURE__*/React.createElement(StyledIconButton, {
  onClick: onClick,
  className: className,
  "aria-label": ariaLabel
}, icon);
const styles = {
  mgb: mgbStyles,
  migipedia: migipediaStyles,
  migipediaDark: migipediaStyles,
  migusto: migustoStyles,
  melectronics: melectronicsStyles,
  sportxx: sportxxStyles,
  micasa: micasaStyles,
  bikeworld: bikeworldStyles,
  doitGarden: doitGardenStyles,
  migrosApp: migrosAppStyles,
  migrosService: migrosServiceStyles,
  famigros: famigrosStyles
};
export const iconButtonStyles = css`
  ${({
  theme: {
    themeId
  }
}) => styles[themeId] || mgbStyles}
  border-radius: 100%;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${ICON_BUTTON_SIZE};
  width: ${ICON_BUTTON_SIZE};
`;
const StyledIconButton = styled.button.withConfig({
  shouldForwardProp: isPropValid
})`
  ${iconButtonStyles}
`;